module.exports = __webpack_public_path__ + "static/media/1.3058fa5d.png";